<script setup lang="ts">
import { Result, Button } from 'ant-design-vue';
import { useRouter } from 'vue-router';

import HeadTitle from '@/ui/HeadTitle.vue';

const router = useRouter();
const goHome = () => {
  router.replace({ name: 'schools' });
};
</script>

<template>
  <HeadTitle title="403 Forbidden" />
  <Result
    status="403"
    title="403 Forbidden"
    sub-title="Sorry, you are not authorized to access this page."
  >
    <template #extra>
      <Button type="primary" @click="goHome">
        Back Home
      </Button>
    </template>
  </Result>
</template>
